// ----------------------------------------------------------------------------
// Component: Page Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';
import 'snippets/video-player/video-block'; //if using page-hero--video

// Styles
import './_page-hero.scss';
import './_page-hero--content-layout.scss';

// Page Header Search
var SEARCH_TYPE_TAB = '.search-type__wrapper .search-type';
var ACTIVE_CLASS = 'is-active';
document.addEventListener('DOMContentLoaded', function () {
  var urlParams = new URLSearchParams(window.location.search);
  var currentType = urlParams.get('type') || 'product,page,article';
  console.log('Current Search Type:', currentType);
  document.querySelectorAll(SEARCH_TYPE_TAB).forEach(tab => {
    var hrefTypeMatch = tab.getAttribute('href').match(/type=([^&]+)/);
    if (hrefTypeMatch && hrefTypeMatch[1] === currentType) {
      tab.classList.add(ACTIVE_CLASS);
    }
  });
});